<script lang="ts">
    import {
      Button,
      Col,
      ButtonGroup,
      DropdownToggle,
      DropdownMenu,
      DropdownItem,
      Dropdown,
    } from 'sveltestrap'
    import Card from "../../Core/Card.svelte";
    import { Makenestingbuttons } from '../../../utils/Constant/Constant';
</script>
  
  <!-- Need to check checked checkbox design -->
<Col lg="6">
    <Card headerTitle="Nesting" cardBodyprops="btn-group-showcase">
      <div slot="customheader">
        <span>{Makenestingbuttons}</span>
      </div>
      <div slot="contentbody">
        <div class="m-b-30 btn-group-horizontal">
          <ButtonGroup>
            <Button color="primary">
              <i class="fa fa-bold" />
            </Button>
            <Button color="secondary">
              <i class="fa fa fa-italic" />
            </Button>
            <Dropdown>
              <DropdownToggle caret color="light">Dropdown</DropdownToggle>
              <DropdownMenu class="dropdown-button-group">
                <DropdownItem header>Header</DropdownItem>
                <DropdownItem disabled>Action</DropdownItem>
                <DropdownItem>Another Action</DropdownItem>
                <DropdownItem>Another Action</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ButtonGroup>
        </div>
        <div class="m-b-30">
          <ButtonGroup>
            <Button color="primary">
              <i class="fa fa-bold" />
            </Button>
            <Button color="secondary">
              <i class="fa fa fa-italic" />
            </Button>
            <Button color="success">
              <i class="fa fa-file-image-o" />
            </Button>
            <Button color="info">
              <i class="fa fa-paperclip" />
            </Button>
          </ButtonGroup>
        </div>
        <div class="m-b-30">
          <ButtonGroup>
            <Button color="primary" size="lg">
              <i class="fa fa-bold" />
            </Button>
            <Button color="secondary" size="lg">
              <i class="fa fa fa-italic" />
            </Button>
            <Button color="success" size="lg">
              <i class="fa fa-file-image-o" />
            </Button>
            <Button color="info" size="lg">
              <i class="fa fa-paperclip" />
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Card>
</Col>
  